import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>CCX Pending Load</h2>
  <h3>SOP</h3>
  <h4>Less than 90% of CCX packages loaded x minutes prior to CPT:</h4>
  <h4>If incomplete:</h4>
  <p>Medium severity escalation created if less than 90% of CCX packages loaded 90 minutes prior to CPT - site level POCs receive push notification that package is at risk of missing CPT.</p>
  <p><strong>Action item:</strong> Navigate to HAWK, using SSP Tool identify last known location of package. Go get the package and scan it to the trailer. If package can't be found, add notes to the HAWK case. Do not close the case until after CPT.</p>
  <p><strong>If complete, escalation closes automatically with scan to appropriate outbound load.</strong></p>

  <h4>If incomplete:</h4>
  <p>Critical severity escalation created if less than 90% of CCX packages loaded 60 minutes prior to CPT - site level POCs receive push notification that package is at risk of missing CPT.</p>
  <p><strong>Action item:</strong> Navigate to HAWK, using SSP Tool identify last known location of package. Go get the package and scan it to the trailer. If package can't be found, make notes why the package missed CPT and the action plan to avoid missing CPT again. Do not close the case until after CPT.</p>
  <p><strong>If complete, escalation closes automatically with scan to appropriate outbound load.</strong></p>

  <h4>Auto-resolves if escalation still open 48 hours past CPT. CE recovery still expected and mandatory:</h4>
  <p>If ops fails to recover packages by critical escalation, packages will miss CPT. Ops must close out HAWK escalation manually, including all details of why package missed CPT in the "notes" section, as well as the expected departure date. Escalations cannot be manually closed until 6 hours past CPT in order to allow opportunity to deep dive misses, provide root causes, and provide actionable items to correct future occurrences.</p>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_CCX_PENDING_LOAD.jsx